import React from 'react';

const MemberManagementMockup = () => {
  return (
    <div className="mockup-container members-mockup">
      <div className="mockup-header-bar">
        <div className="mockup-title">Gestión de Perfiles y Membresías</div>
        <div className="add-btn">+ Nuevo Miembro</div>
      </div>

      <div className="member-stats-row">
        <div className="mini-card">
          <span className="mini-label">Activos</span>
          <span className="mini-val">842</span>
        </div>
        <div className="mini-card">
          <span className="mini-label">Nuevos (Mes)</span>
          <span className="mini-val">+52</span>
        </div>
        <div className="mini-card warning">
          <span className="mini-label">Pendientes Pago</span>
          <span className="mini-val">12</span>
        </div>
      </div>

      <div className="member-profile-preview">
        <div className="profile-header">
          <div className="profile-avatar large">FC</div>
          <div className="profile-info">
            <span className="p-name">Fernando C.</span>
            <span className="p-id">Socio #1024</span>
          </div>
          <span className="p-status">ACTIVO</span>
        </div>
        <div className="profile-details-grid">
          <div className="detail-item">
            <span className="d-label">Crédito Disponible</span>
            <span className="d-val">€45.00</span>
          </div>
          <div className="detail-item">
            <span className="d-label">Última Visita</span>
            <span className="d-val">Hoy, 10:30</span>
          </div>
          <div className="detail-item">
            <span className="d-label">Renovación</span>
            <span className="d-val">12 Jun 2026</span>
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .members-mockup { background: white; border: 1px solid #e5e7eb; border-radius: 12px; padding: 24px; display: flex; flex-direction: column; gap: 20px; }
        .mockup-header-bar { display: flex; justify-content: space-between; align-items: center; }
        .add-btn { background: #059669; color: white; padding: 6px 14px; border-radius: 8px; font-size: 11px; font-weight: 600; }
        
        .member-stats-row { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; }
        .mini-card { background: #f9fafb; padding: 12px; border-radius: 8px; border: 1px solid #e5e7eb; }
        .mini-card.warning { border-color: #fecaca; background: #fff1f1; }
        .mini-label { font-size: 10px; color: #6b7280; display: block; margin-bottom: 4px; }
        .mini-val { font-size: 16px; font-weight: 700; color: #111827; }
        
        .member-profile-preview { background: #fdfdfd; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px; display: flex; flex-direction: column; gap: 16px; box-shadow: 0 4px 12px rgba(0,0,0,0.02); }
        .profile-header { display: flex; align-items: center; gap: 16px; }
        .profile-avatar.large { width: 48px; height: 48px; background: #111827; color: white; border-radius: 12px; display: flex; align-items: center; justify-content: center; font-weight: 700; }
        .profile-info { flex: 1; display: flex; flex-direction: column; }
        .p-name { font-size: 15px; font-weight: 700; color: #111827; }
        .p-id { font-size: 12px; color: #6b7280; }
        .p-status { background: #ecfdf5; color: #059669; font-size: 10px; font-weight: 700; padding: 4px 10px; border-radius: 99px; }
        
        .profile-details-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; padding-top: 16px; border-top: 1px dashed #e5e7eb; }
        .detail-item { display: flex; flex-direction: column; gap: 4px; }
        .d-label { font-size: 10px; color: #9ca3af; }
        .d-val { font-size: 12px; font-weight: 600; color: #374151; }
      `}} />
    </div>
  );
};

export default MemberManagementMockup;
